export default __webpack_public_path__ + "static/media/logo-dark.da150d1d.svg";